<div class="new-user">
  <div class="loading-new-user" *ngIf="isLoading">
    <app-loading [onlyIcon]="true"></app-loading>
    {{ 'COMMONS.LOADING' | i18nextEager }}
  </div>
  <form [formGroup]="newUserForm">
    <section>
      <div class="new-user__form">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'USER_MANAGEMENT.NAME' | i18nextEager }}</mat-label>
          <input matInput formControlName="nombre" maxlength="50" />
          <mat-error
            *ngIf="
              newUserForm?.controls.nombre.errors?.required &&
              (newUserForm?.controls.nombre.touched || newUserForm?.controls.nombre.dirty)
            "
          >
            {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'USER_MANAGEMENT.SURNAME' | i18nextEager }}</mat-label>
          <input matInput formControlName="apellildos" maxlength="50" />
          <mat-error
            *ngIf="
              newUserForm?.controls.apellildos.errors?.required &&
              (newUserForm?.controls.apellildos.touched || newUserForm?.controls.apellildos.dirty)
            "
          >
            {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'USER_MANAGEMENT.DNI' | i18nextEager }}</mat-label>
          <input matInput formControlName="dni" maxlength="10" />
          <mat-error
            *ngIf="
              newUserForm?.controls.dni.errors?.required &&
              (newUserForm?.controls.dni.touched || newUserForm?.controls.dni.dirty)
            "
          >
            {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
          </mat-error>
          <mat-error
            *ngIf="
              newUserForm?.controls.dni.errors &&
              newUserForm?.controls.dni.value &&
              (newUserForm?.controls.dni.touched || newUserForm?.controls.dni.dirty)
            "
          >
            {{ 'USER_MANAGEMENT.INVALID_DNI' | i18nextEager }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'USER_MANAGEMENT.EMAIL' | i18nextEager }}</mat-label>
          <input matInput formControlName="email" maxlength="50" />
          <mat-error
            *ngIf="
              newUserForm?.controls.email.errors?.required &&
              (newUserForm?.controls.email.touched || newUserForm?.controls.email.dirty)
            "
          >
            {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
          </mat-error>
          <mat-error
            *ngIf="
              newUserForm?.controls.email.errors &&
              newUserForm?.controls.email.value &&
              (newUserForm?.controls.email.touched || newUserForm?.controls.email.dirty)
            "
          >
            {{ 'USER_MANAGEMENT.INVALID_EMAIL' | i18nextEager }}
          </mat-error>
        </mat-form-field>
        <div class="new-user__toggle">
          <label>{{ 'USER_MANAGEMENT.ROLE' | i18nextEager }}</label>
          <mat-radio-group
            aria-labelledby=""
            formControlName="codigoRol"
            ngDefaultControl
            required
            class="radion_button"
          >
            <mat-radio-button value="300000005" *ngIf="roleCode !== '300000003' && roleCode !== '300000004'">
              <span>{{ 'USER_MANAGEMENT.CHANNEL_BACKOFFICE' | i18nextEager }}</span>
            </mat-radio-button>
            <mat-radio-button value="300000003">
              <span>{{ 'USER_MANAGEMENT.CHANNEL_MANAGER' | i18nextEager }}</span>
            </mat-radio-button>
            <mat-radio-button value="300000004">
              <span>{{ 'USER_MANAGEMENT.CHANNEL_COMMERCIAL' | i18nextEager }}</span>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="new-user__permissions">
          <mat-checkbox
            *ngIf="newUserForm.controls.codigoRol.value === '300000004'"
            (change)="handlePermission($event, this.permissions[this.permissions['only read']])"
          >
            {{ 'USER_MANAGEMENT.ONLY_READ' | i18nextEager }}
          </mat-checkbox>
          <mat-checkbox
            *ngIf="
              newUserForm.controls.codigoRol.value === '300000005' ||
              newUserForm.controls.codigoRol.value === '300000003'
            "
            (change)="handlePermission($event, this.permissions[this.permissions['create user']])"
          >
            {{ 'USER_MANAGEMENT.USER_CREATION' | i18nextEager }}
          </mat-checkbox>
          <mat-checkbox
            *ngIf="
              (newUserForm.controls.codigoRol.value === '300000005' ||
                newUserForm.controls.codigoRol.value === '300000003') &&
              hasSettlementAccess
            "
            (change)="handlePermission($event, this.permissions[this.permissions['settlement view']])"
          >
            {{ 'USER_MANAGEMENT.ACCESS_SETTLEMENT' | i18nextEager }}
          </mat-checkbox>
        </div>

        <div *ngIf="newUserForm.controls.codigoRol.value">
          <mat-form-field appearance="outline">
            <mat-label>{{ rolSelectedLabel | i18nextEager }}</mat-label>
            <input
              matInput
              maxlength="50"
              formControlName="search"
              [placeholder]="rolSelectedPlaceholder | i18nextEager"
            />
            <button
              (click)="search(newUserForm.controls.codigoRol.value, newUserForm.controls.search.value)"
              class="suffix-icon"
            >
              <img src="/assets/icons/search.svg" alt="" />
            </button>
          </mat-form-field>
        </div>

        <div *ngIf="isLoadingResults; else results">
          <app-loading [onlyIcon]="true"></app-loading>
        </div>

        <ng-template #results>
          <div class="results" *ngIf="managerList && newUserForm.controls.codigoRol.value">
            <div class="results__count">{{ managerList.length }} {{ 'USER_MANAGEMENT.RESULTS' | i18nextEager }}</div>
            <div class="results__data" *ngIf="managerList.length">
              <mat-radio-group aria-labelledby="" formControlName="codigoGestorCanal">
                <mat-radio-button
                  [value]="item.codigoCRMUser"
                  class="results__data__item"
                  *ngFor="let item of managerList"
                >
                  <div>{{ item.dniUser }}</div>
                  <div>{{ item.nombreUser }}</div>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </ng-template>
      </div>
    </section>
  </form>
</div>
